


import * as THREE from 'three';

import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { Reflector } from 'three/addons/objects/Reflector.js';
//import Stats from 'three/addons/libs/stats.module.js';
import VertexShader from './shaders/vertex.glsl';
import FragmentShader from './shaders/fragment.glsl';
import VertexShaderLeaf from './shaders/vertex_leaf.glsl';
import FragmentShaderLeaf from './shaders/fragment_leaf.glsl';
//import { RectAreaLightHelper } from 'three/addons/helpers/RectAreaLightHelper.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'
			
			


let camera, scene, renderer, controls, clock;

// variables for small morphoings between transitions
let mesh // figure 1 
let mixer = null // figure 1 
let mesh_2 // figure 2 
let mixer_2 = null // figure 2	

let sound;

//UI elements taken from HTML and CSS
let instructions_clicked = false;
let title,logo,description,continue_ref,restart_ref;
let continue_clicked=false;

let comment_container;
let img_comment, img_nocomment;

const Description  = {
	showing: false,
	show() {
		if(this.showing == false){
			description_container.style.opacity = 1;
			description_container.style.visibility = "visible";
			img_comment.style.display = "block";
			img_nocomment.style.display = "none";
			this.showing = true;
		}
	},
	hide() {
		if(this.showing == true){
			description_container.style.opacity = 0;
			img_comment.style.display = "none";
			img_nocomment.style.display = "block";
			this.showing = false;
			description_container.style.visibility = "hidden";
		}
	},
	toggle(){
		if(this.showing== true){
			this.hide();
		}
		else{
			this.show();
		}
	}
}

//variables for physics ( moving with keys and looking around)
const _vector = new THREE.Vector3();

let moveForward = false;
let moveBackward = false;
let moveLeft = false;
let moveRight = false;

let prevTime = performance.now();
const velocity = new THREE.Vector3();
const direction = new THREE.Vector3();

//variabls for transitions
//let transition;
let anim_triggered = false;
let anim_finished = false;


let touchdevice = false;

//post rendering 
let effectComposer;
let unrealBloomPass;



let groundMirror; // floor reflection
let floor; //floor overlay color
let upperLight,lowerLight; // lights

let time;
//let stats;
let scanLight;


//plant scene
let plant_shader;
let scene_plants = [
	//0 - plant01, 2- plant02 , 3 plant03
	{
		'name'	   :  'plant_0',
		'position' :  [-20,40,50],
		'rotation' :  [0,Math.PI/2,Math.PI/2],
		'size'	   :  500,
		'model'    :  0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_1',
		'position' :  [-60,40,50],
		'rotation' :  [0,Math.PI/4,Math.PI/2],
		'size'	   :  500,
		'model'    :  0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_2',
		'position' :  [50,60,100],
		'rotation' :  [Math.PI,Math.PI/2,Math.PI/2],
		'size'	   :  300,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_3',
		'position' :  [80,50,100],
		'rotation' :  [Math.PI/6,0,Math.PI/2],
		'size'	   :  500,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_4',
		'position' :  [-30,50,0],
		'rotation' :  [Math.PI/6,0,Math.PI/2],
		'size'	   :  1000,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_5',
		'position' :  [0,30,80],
		'rotation' :  [Math.PI/6,0,Math.PI/2],
		'size'	   :  300,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_6',
		'position' :  [-50,60,0],
		'rotation' :  [-Math.PI/6,0,-Math.PI],
		'size'	   :  900,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_7',
		'position' :  [50,60,40],
		'rotation' :  [-Math.PI/4,0,Math.PI/4],
		'size'	   :  800,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_8',
		'position' :  [-120,100,20],
		'rotation' :  [-Math.PI/4,0,Math.PI],
		'size'	   :  800,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_9',
		'position' :  [20,50,100],
		'rotation' :  [-Math.PI/4,0,Math.PI],
		'size'	   :  300,
		'model'    : 2// 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_28',
		'position' :  [-30,100,100],
		'rotation' :  [-Math.PI/4,0,Math.PI],
		'size'	   :  300,
		'model'    : 2// 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_10',
		'position' :  [0,30,-80],
		'rotation' :  -[Math.PI/6,0,Math.PI/2],
		'size'	   :  300,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_11',
		'position' :  [10,50,0],
		'rotation' :  [Math.PI/6,0,Math.PI/2],
		'size'	   :  200,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_12',
		'position' :  [10,50,-30],
		'rotation' :  [Math.PI/6,0,Math.PI/2],
		'size'	   :  400,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_13',
		'position' :  [80,60,0],
		'rotation' :  [-Math.PI,0,-Math.PI],
		'size'	   :  900,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_14',
		'position' :  [40,20,0],
		'rotation' :  [-Math.PI,0,0],
		'size'	   :  200,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_15',
		'position' :  [40,40,0],
		'rotation' :  [-Math.PI/6,0,0],
		'size'	   :  600,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_16',
		'position' :  [40,40,0],
		'rotation' :  [-Math.PI/6,0,0],
		'size'	   :  600,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_17',
		'position' :  [40,40,-30],
		'rotation' :  [-Math.PI/6,0,0],
		'size'	   :  400,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_18',
		'position' :  [0,90,-90],
		'rotation' :  [-Math.PI/6,0,0],
		'size'	   :  400,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_27',
		'position' :  [60,90,-20],
		'rotation' :  [-Math.PI/6,0,0],
		'size'	   :  800,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_19',
		'position' :  [20,90,-20],
		'rotation' :  [-Math.PI,Math.PI,0],
		'size'	   :  800,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_20',
		'position' :  [80,20,-20],
		'rotation' :  [-Math.PI,Math.PI,0],
		'size'	   :  800,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_21',
		'position' :  [0,20,-80],
		'rotation' :  [-Math.PI,Math.PI,0],
		'size'	   :  800,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_22',
		'position' :  [-30,20,150],
		'rotation' :  [0,Math.PI,0],
		'size'	   :  1500,
		'model'    : 2 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_23',
		'position' :  [30,20,150],
		'rotation' :  [Math.PI,0,Math.PI/2],
		'size'	   :  500,
		'model'    : 1 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_24',
		'position' :  [0,80,100],
		'rotation' :  [Math.PI/2,Math.PI/2,Math.PI/4],
		'size'	   :  1000,
		'model'    : 0 // 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_25',
		'position' :  [10,100,60],
		'rotation' :  [Math.PI/2,Math.PI/2,Math.PI/4],
		'size'	   :  1000,
		'model'    : 1// 3 arrays of plants to load

	},
	{
		'name'	   :  'plant_26',
		'position' :  [50,100,138],
		'rotation' :  [Math.PI/2,Math.PI/2,Math.PI/4],
		'size'	   :  500,
		'model'    : 2// 3 arrays of plants to load

	},

];

//light gradient on the ground
let mesh_gradient,mesh_gradient_2;
let light_gradient,light_gradient_2;

init();
animate();

function init() {

	touchdevice = isTouchDevice();
	//touchdevice = true;



	scene = new THREE.Scene();
	scene.background = new THREE.Color( 0x020202 );

	
	/* UI stuff */
	const intro = document.getElementById( 'intro' );
	const blocker = document.getElementById( 'blocker' );
	title = document.getElementById( 'title' );
	description = document.getElementById( 'description' );
	const description_container = document.getElementById( 'description_container' );
	description_container.style.opacity = 0;
	logo = document.getElementById( 'logo' );
	const instructions = document.getElementById( 'instructions' );
	const container_block = document.getElementById( 'container' );
	const sound_container =  document.getElementById( 'sound' ); // clickable element with both icons in UI 
	const img_nosound = document.getElementById( 'img_nosound' );
	const img_sound = document.getElementById( 'img_sound' );
	comment_container =  document.getElementById( 'comment' ); // clickable element with both icons in UI 
	img_nocomment = document.getElementById( 'img_nocomment' );
	img_comment = document.getElementById( 'img_comment' );
	continue_ref = document.getElementById( 'continue' );
	continue_ref.style.opacity = 0;
	continue_ref.style.display = "none";
	restart_ref = document.getElementById( 'restart' );
	restart_ref.style.opacity = 0;
	restart_ref.style.display = "none";

	sound_container.style.display= "none";
	comment_container.style.display= "none";
	

	if(touchdevice){
		instructions.getElementsByClassName('mobile_instructions')[0].style.display= "block";
		instructions.getElementsByClassName('desktop_instructions')[0].style.display= "none";
		instructions.getElementsByClassName('desktop_instructions')[1].style.display= "none";
	}
	
	sound_container.addEventListener('pointerdown', function handleClick() {
		if(sound.isPlaying ==false)
		{	
			sound.play();
			img_sound.style.display = "block";
			img_nosound.style.display = "none";
		}
		else{
			sound.pause();
			img_nosound.style.display = "block";
			img_sound.style.display = "none";
		}
	});

	comment_container.addEventListener('pointerdown', function handleClick() {
		Description.toggle();
	});

	description_container.addEventListener('pointerdown', function handleClick() {
		Description.hide();
	});

	intro.addEventListener('pointerdown', (event) =>  {
		intro.style.opacity = 0;
		intro.style.display = "none";
		blocker.style.opacity = 0;
		instructions.style.display = "block";
		instructions.offsetHeight;
		title.classList.add('intro_title');
		instructions.style.opacity = 1;


	},{once : true});

	instructions.addEventListener('pointerdown', function handleClick() {


		sound_container.style.display= "block";
		sound_container.style.opacity = 1;
		img_sound.style.display = "block";
		img_nosound.style.display = "none";

		continue_ref.style.opacity = 1;
		continue_ref.style.display = "block";

		container_block.style.opacity = 0;
		title.classList.remove('intro_title');
		title.classList.add('slide1_title');

		//show comment icons UI 
		comment_container.style.display= "block";
		
		
		Description.show();

		//Show description
		description_container.style.opacity = 1;
		description.innerHTML = "Our natural world’s metal binds and flexes. It breathes and beats. And it loves. Nature’s metal flows as air and wind, effortlessly sculpting fantastical forms from which the highest resolutions of inspiration emerge.";

		
		instructions_clicked = true;
		instructions.style.opacity = 0;
		instructions.style.display = "none";
		// create an AudioListener and add it to the camera
		const listener = new THREE.AudioListener();
		camera.add( listener );

		// create a global audio source
		sound = new THREE.Audio( listener );

		// load a sound and set it as the Audio object's buffer
		const audioLoader = new THREE.AudioLoader();
		audioLoader.load( './sounds/bg.mp3', function( buffer ) {
			sound.setBuffer( buffer );
			sound.setLoop( true );
			sound.setVolume( 0.5 );
			sound.play();
		});
	

		},{once : true});

		continue_ref.addEventListener('pointerdown', function handleClick() {
		if(continue_clicked==false){
			continue_ref.style.opacity = 0;
			continue_ref.style.display = "none";
			continue_clicked = true; 
		}

		});

		restart_ref.addEventListener('pointerdown', function handleClick() {
			window.location.reload();
			});


	camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 1, 1000 );


	//setting up orbit contrls

	controls = new OrbitControls( camera, document.body );
	controls.listenToKeyEvents( window ); // optional

	controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
	controls.dampingFactor = 0.05;

	controls.screenSpacePanning = false;

	controls.zoom = 10;
	controls.minDistance = 10;
	controls.maxDistance = 150;
	controls.zoomSpeed = .5;
	controls.rotateSpeed = .2;

	if(touchdevice){
		controls.target.set(0,7,0);
		controls.maxPolarAngle =  Math.PI/1.97;
		controls.minPolarAngle = Math.PI/2.5;
	}
	else{
		controls.target.set(30,7,-30);
		controls.maxPolarAngle =  Math.PI/2.1;
		controls.minPolarAngle = Math.PI/2.1;
	}
	
	camera.position.x = 100;
	camera.position.y = 8;
	camera.position.z = -100;

	const onKeyDown = function ( event ) {
		if(instructions_clicked){

		switch ( event.code ) {

			case 'ArrowUp':
			case 'KeyW':
				moveForward = true;
				break;

			case 'ArrowLeft':
			case 'KeyA':
				moveLeft = true;
				break;

			case 'ArrowDown':
			case 'KeyS':
				moveBackward = true;
				break;

			case 'ArrowRight':
			case 'KeyD':
				moveRight = true;
				break;

		}
	}

	};

	const onKeyUp = function ( event ) {

		switch ( event.code ) {

			case 'ArrowUp':
			case 'KeyW':
				moveForward = false;
				break;

			case 'ArrowLeft':
			case 'KeyA':
				moveLeft = false;
				break;

			case 'ArrowDown':
			case 'KeyS':
				moveBackward = false;
				break;

			case 'ArrowRight':
			case 'KeyD':
				moveRight = false;
				break;

		}

	};

	document.addEventListener( 'keydown', onKeyDown );
	document.addEventListener( 'keyup', onKeyUp );

	//animation clock 
	clock = new THREE.Clock();


	// stats = new Stats();
	// container.appendChild( stats.dom );


	// floor

	let floorGeometry = new THREE.PlaneGeometry( 2000, 2000, 1, 1 );
	const floorMaterial = new THREE.MeshBasicMaterial( { color: 0x000000,transparent:true, opacity: .8} );
	floorGeometry.rotateX( - Math.PI / 2 );
	floor = new THREE.Mesh( floorGeometry, floorMaterial );
	floor.position.y=2;
	scene.add( floor );

	let mirrorGeometry = new THREE.PlaneGeometry( 2000, 2000, 1, 1 );

	groundMirror = new Reflector( mirrorGeometry, {
		//clipBias: 0.003,
		textureWidth: window.innerWidth * window.devicePixelRatio,
		textureHeight: window.innerHeight * window.devicePixelRatio
	} );
	groundMirror.rotateX( - Math.PI / 2 );
	scene.add( groundMirror );


	/* ----- LIGHTS -------- */

	//Radar light
	scanLight = new THREE.DirectionalLight( 0xffffff, 50);
	scanLight.position.set( 0, -10, 0 );
	//scanLight.rotateY(Math.PI/2);
	//scanLight.rotateX(Math.PI/2);
	//scene.add( scanLight );
	//scene.add( new THREE.DirectionalLightHelper( scanLight ) );

	//upper light
	upperLight = new THREE.DirectionalLight(0xB2F1FF,.7)
	upperLight.position.y = 80;
	scene.add(upperLight);
	//scene.add( new THREE.DirectionalLightHelper( upperLight ) );

	//lower light
	lowerLight = new THREE.PointLight(0xffffff, .5)
	lowerLight.position.y = -40;
	scene.add(lowerLight);


	/* ---------light gradient GLSL shader ---------*/


	/* first half */

	//Geometry
	const geometry_gradient = new THREE.PlaneGeometry(100,3,32,32);
	geometry_gradient.scale(10,10,10);
	geometry_gradient.rotateX(-Math.PI/2);

	//Material 
	light_gradient = new THREE.RawShaderMaterial({
		vertexShader: VertexShader,
		fragmentShader : FragmentShader,
		uniforms : {
			u_Opacity : {value : 1.0},
			u_flip :{value : true},
		},
		transparent: true
		
	});

	//Mesh
	mesh_gradient = new THREE.Mesh(geometry_gradient,light_gradient);
	mesh_gradient.position.y = 2.5;
	scene.add(mesh_gradient);



	/* second half */

	//Geometry
	const geometry_gradient_2 = new THREE.PlaneGeometry(100,3,32,32);
	geometry_gradient_2.scale(10,10,10);
	geometry_gradient_2.rotateX(-Math.PI/2);
	//geometry_gradient_2.rotateX(-Math.PI/2);

	//Material 
	light_gradient_2 = new THREE.RawShaderMaterial({
		vertexShader: VertexShader,
		fragmentShader : FragmentShader,
		uniforms : {
			u_Opacity : {value : 1.0},
			u_flip :{value : false},
		},
		transparent: true
		
	});

	//Mesh
	mesh_gradient_2 = new THREE.Mesh(geometry_gradient_2,light_gradient_2);
	mesh_gradient_2.position.y = 2.5;
	scene.add(mesh_gradient_2);


	/* GLTF Loaders */




	//Model 1 

	const loader_obj1 = new GLTFLoader();
	loader_obj1.load( './models/Model_01_UV_Chonk.gltf', function ( gltf ) {
		gltf.scene.name = 'obj1';
		gltf.scene.scale.set(3,3,3);
		gltf.scene.position.setY(9);
		scene.add(gltf.scene);

		const children = [...gltf.scene.children];
		for(const child of children){
			if (child instanceof THREE.Mesh) {
				//child.visible = false;
				//child.material.opacity = .3;
				child.material.opacity = 1;
				child.material.transparent = true;
				child.material.roughness = 0.40;
				child.material.metalness = 1;
			}
		}	
	
	}, undefined, function ( error ) {
	
		console.error( error );
	
	} );

	//Figure 2 ( morphing) 
	const loader_init_obj = new GLTFLoader();
	loader_init_obj.load( './models/MorphShape.gltf', function ( gltf ) {

		mesh_2 = gltf.scene.children[ 0 ];
		mesh_2.scale.set(250,250,250);
		mesh_2.position.setY(11);
		mesh_2.material.transparent = true;
		scene.add( mesh_2 );
		

		mixer_2 = new THREE.AnimationMixer( mesh_2 );
		const action_2 = mixer_2.clipAction(gltf.animations[0])
		action_2.loop = THREE.LoopOnce;
		action_2.clampWhenFinished = true;
		action_2.play()
		mesh_2.material.opacity = 1;
		mixer_2.timeScale = 0;
		mesh_2.visible = false;

	
	}, undefined, function ( error ) {
	
		console.error( error );
	
	} );

	// Morphing of leaves to car

	const loader_obj4 = new GLTFLoader();
	loader_obj4.load( './models/MorphLeaves.gltf', function ( gltf ) {
		gltf.scene.name = 'Morph';
		
		mesh = gltf.scene.children[ 0 ];
		mesh.scale.set(3,3,3);
		mesh.position.setY(4);

		mesh.material.transparent = true;
		scene.add( mesh );
		

		mixer = new THREE.AnimationMixer( mesh );
		const action = mixer.clipAction(gltf.animations[0])
		action.loop = THREE.LoopOnce;
		action.clampWhenFinished = true;
		action.play()
		mixer.timeScale = 0;
		mesh.material.side = THREE.DoubleSide;
		mesh.material.emissive.setHex( 0x0DE689);
		mesh.material.emissiveIntensity = .2;
		mesh.material.color.setHex( 0x0DE689 );
		mesh.material.opacity = .6;
		mesh.visible = false;

	
	}, undefined, function ( error ) {
	
		console.error( error );
	
	} );

	//model 3
	
	const loader_obj3 = new GLTFLoader();
	loader_obj3.load( './models/Concept.gltf', function ( gltf ) {
		gltf.scene.name = 'obj3';
		gltf.scene.scale.set(3,3,3);
		gltf.scene.position.setY(4);
			
		const children = [...gltf.scene.children];

		for(const child of children){

			for(let i= 0; i<=child.children.length;i++){
				if (child.children[i] instanceof THREE.Mesh) {
					child.children[i].visible = false;
					child.children[i].material.transparent = true;
					//child.children[i].material.emissive = new THREE.Color(255, 255, 255);
					child.children[i].material.opacity = 0;
					//child.children[i].material = new THREE.MeshPhongMaterial({color: 0x000000});
					}
			}		

		}		
		scene.add(gltf.scene);
	
	}, undefined, function ( error ) {
	
		console.error( error );
	
	} );


	//Renderer

	renderer = new THREE.WebGL1Renderer( { antialias: true } );
	renderer.setPixelRatio( window.devicePixelRatio );
	renderer.setSize( window.innerWidth, window.innerHeight );
	document.body.appendChild( renderer.domElement );


	/* -- Leaves * ---- */

	//Material
	plant_shader = new THREE.RawShaderMaterial({
		vertexShader: VertexShaderLeaf,
		fragmentShader : FragmentShaderLeaf,
		uniforms : {
			u_time: {value : 0.0 },
			u_opacity : {value : 0}
		},
		side: THREE.DoubleSide,
		transparent: true
	});
	

	for ( let i = 0; i < scene_plants.length; i ++ ) {

	const loader_leaf= new GLTFLoader();
	if(scene_plants[i].model == 0){
		loader_leaf.load( './models/Leaf01.gltf', function ( gltf ) {

			const children = [...gltf.scene.children];
			for(const child of children){
				if (child instanceof THREE.Mesh) {
					child.material = plant_shader;
					child.material.side = THREE.DoubleSide;
					child.visible = false;
				}
			}	
			
			
			gltf.scene.scale.set(scene_plants[i].size,scene_plants[i].size,scene_plants[i].size);
			gltf.scene.name = scene_plants[i].name;
			gltf.scene.position.set(scene_plants[i].position[0],scene_plants[i].position[1]-15,scene_plants[i].position[2]);
			gltf.scene.rotation.set(scene_plants[i].rotation[0],scene_plants[i].rotation[1]-15,scene_plants[i].rotation[2]);

			scene.add( gltf.scene );
		
		}, undefined, function ( error ) {
		
			console.error( error );
		
		} );
	}
	
	else if(scene_plants[i].model == 1){
		loader_leaf.load( './models/Leaf02.gltf', function ( gltf ) {

			gltf.scene.scale.set(scene_plants[i].size,scene_plants[i].size,scene_plants[i].size);
			gltf.scene.name = scene_plants[i].name;
			gltf.scene.position.set(scene_plants[i].position[0],scene_plants[i].position[1]-15,scene_plants[i].position[2]);
			gltf.scene.rotation.set(scene_plants[i].rotation[0],scene_plants[i].rotation[1]-15,scene_plants[i].rotation[2]);

			scene.add( gltf.scene );

			const children = [...gltf.scene.children];
			for(const child of children){
				if (child instanceof THREE.Mesh) {
					child.material = plant_shader;
					child.material.side = THREE.DoubleSide;
					child.visible = false;
				}
			}		
		
		}, undefined, function ( error ) {
		
			console.error( error );
		
		} );
	}
	else if(scene_plants[i].model == 2){
		loader_leaf.load( './models/Leaf03.gltf', function ( gltf ) {

			gltf.scene.scale.set(scene_plants[i].size,scene_plants[i].size,scene_plants[i].size);
			gltf.scene.name = scene_plants[i].name;
			gltf.scene.position.set(scene_plants[i].position[0],scene_plants[i].position[1]-15,scene_plants[i].position[2]);
			gltf.scene.rotation.set(scene_plants[i].rotation[0],scene_plants[i].rotation[1]-15,scene_plants[i].rotation[2]);

			scene.add( gltf.scene );

			const children = [...gltf.scene.children];
			for(const child of children){
				if (child instanceof THREE.Mesh) {
					child.material = plant_shader;
					child.material.side = THREE.DoubleSide;
					child.visible = false;
				}
			}		
		
		}, undefined, function ( error ) {
		
			console.error( error );
		
		} );
	}

}



	/**
		* Post processing
		*/

	effectComposer = new EffectComposer(renderer);
	//effectComposer.setSize( window.innerWidth, window.innerHeigh);
	effectComposer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

	const renderPass = new RenderPass(scene, camera)
	effectComposer.addPass(renderPass)

	unrealBloomPass = new UnrealBloomPass()
	effectComposer.addPass(unrealBloomPass);

	unrealBloomPass.strength = 0.18;
	unrealBloomPass.radius = 1;
	unrealBloomPass.threshold = 0.1;

	window.addEventListener( 'resize', onWindowResize );

}

function onWindowResize() {

	camera.aspect = window.innerWidth / window.innerHeight;
	camera.updateProjectionMatrix();

	groundMirror.getRenderTarget().setSize(
		window.innerWidth * window.devicePixelRatio,
		window.innerHeight * window.devicePixelRatio
	);

	renderer.setSize( window.innerWidth, window.innerHeight );

}



/* MAIN Animation function */

function animate() {

	const clock_delta = clock.getDelta();

	//timespan for morphing animations ( leaves and model 2)

	if ( mixer ) {
		mixer.update(clock_delta);
	}
	if(mixer_2){
		mixer_2.update(clock_delta);
	}


	controls.enabled = false; // avoid conflict with orbits
	const obj1 = scene.getObjectByName('obj1');

	// if(anim_triggered == false){ // First animation starts with distance to center, check
	// 	const center = new THREE.Vector3( );
	// 	var camera_distance = camera.position.distanceTo(center);
	// }

	requestAnimationFrame( animate );

//	stats.update();

	/* Movement with keys */

	time = performance.now();

	const delta = ( time - prevTime ) / 1000;

	velocity.x -= velocity.x * 5.0 * delta;
	velocity.z -= velocity.z * 5.0 * delta;

	velocity.y -= 9.8 * 100.0 * delta; // 100.0 = mass

	direction.z = Number( moveForward ) - Number( moveBackward );
	direction.x = Number( moveRight ) - Number( moveLeft );
	direction.normalize(); // this ensures consistent movements in all directions

	if ( moveForward || moveBackward ) velocity.z -= direction.z * 200.0 * delta;
	if ( moveLeft || moveRight ) velocity.x -= direction.x * 200.0 * delta;


	fmoveRight( - velocity.x * delta );
	fmoveForward( - velocity.z * delta );

	 /* ----- */

	
	ScanLight_move(scanLight); // moves the gradient on the ground
	prevTime = time;
	plant_shader.uniforms.u_time.value +=  clock_delta; // for waving movement on leaves

	controls.enabled = true; // retake orbit controls
	controls.update();

	if((continue_clicked == true) && (anim_triggered == false)&&(anim_finished!=true)){
		anim_triggered = true;
		continue_ref.style.display = "none";
		continue_clicked = false;
		Trigger_animations();
	}

	renderer.render( scene, camera );
	effectComposer.render();

}

// This functions moves the light through the scene and rotates objects that pass
function ScanLight_move(light){

	const obj1 = scene.getObjectByName('obj1');

	if(light.position.z <= 100){ //Marks the speed of the line moving
		light.position.z += 1;

	}
	else{
		light.position.z = -100;
	}

	mesh_gradient.position.z = light.position.z;
	mesh_gradient_2.position.z = light.position.z-30.0;
	
	//smooth transparency on line
	light_gradient.uniforms.u_Opacity.value = THREE.MathUtils.mapLinear(Math.abs(light.position.z),65,100,1,0);
	light_gradient_2.uniforms.u_Opacity.value = THREE.MathUtils.mapLinear(Math.abs(light.position.z),65,100,1,0);
	light.intensity = THREE.MathUtils.mapLinear(Math.abs(light.position.z),0,20,20,0);

	//object move wiht wind
	if(obj1)
		obj1.rotateY(-(light_gradient.uniforms.u_Opacity.value)*.005);

	if(mesh_2)
		mesh_2.rotateY(-(light_gradient.uniforms.u_Opacity.value)*.005);


}


/* ASYNC FUNCTIONS AKA LEVELS */

async function Trigger_animations() {
	await Anim1();
	await Anim2();
	await Anim3();
}

/* Scene 03 Car model */
/* -- Deletes leaves , shows leave to car morphiing and final model */

function Anim3() {

	const obj3 = scene.getObjectByName('obj3');
	let delta_2 = 1;  // this variable funtions as a gradient change for background and scene
	let delt_3 = 0; // to fade in last model after animation
	let morph_finished = false;
	let leaves_removed = false;

	return new Promise(function (resolve, reject) {
		(function waitForLine(){


	
		// when animation finished delete leaves
		mixer.addEventListener( 'finished', function( e ) { 
			morph_finished = true;	
		
		} );


		if(morph_finished){
			if(delt_3 < 1){
				delt_3 += .02;

				//show car ( just one mesh with the line)
				obj3.children[0].children[1].visible = true;
				obj3.children[0].children[1].material.opacity = delt_3;	
				
				//filter change
				unrealBloomPass.strength = THREE.MathUtils.mapLinear(delt_3,0,1,.25,2);
				unrealBloomPass.radius = delt_3;
				unrealBloomPass.threshold = THREE.MathUtils.mapLinear(delt_3,0,1,.1,.01);


				mesh.material.opacity = 1-delt_3;
				

			}
			else{

				restart_ref.style.opacity = 1;
				restart_ref.style.display = "block";

				mesh.material.visible = false;
				anim_finished = true;
				description.innerHTML = "";
				//Description.hide();
				comment_container.style.pointerEvents = "none";
	
				return resolve();	
			}
		}


		if(continue_clicked && (anim_finished == false)){ // check when user clicked next 

			//target camera towards center
			controls.enabled = false; // avoid conflict with orbitto change target
			const new_target = new THREE.Vector3(0,7,0);


			mesh.visible = true; // start leaf morph animation 
			mixer.timeScale = 1.3; // start leav morph animation						
			floor.material.opacity = .8; // floor initial opacity


			if(plant_shader.uniforms.u_opacity.value >= 0){
				delta_2 -= .009;  
				plant_shader.uniforms.u_opacity.value = THREE.MathUtils.mapLinear(delta_2,1,0,.8,0);
				lowerLight.intensity = THREE.MathUtils.mapLinear(delta_2,1,0,.5,0);
				upperLight.intensity = THREE.MathUtils.mapLinear(delta_2,1,0,.3,0);
				// lowerLight.intensity = THREE.MathUtils.mapLinear(delta_2,1,0,.1,0);
				// upperLight.intensity = THREE.MathUtils.mapLinear(delta_2,1,0,.1,0);
				floor.material.opacity = THREE.MathUtils.mapLinear(delta_2,1,0,.5,.8);
				//mesh.material.opacity = THREE.MathUtils.mapLinear(delta_2,1,0,0,1); // morphing leaves
				mesh.material.emissiveIntensity = 1-delta_2;


				//direct camera towards center 
				controls.target.lerp(new_target,1-delta_2);

				//mesh.material.emissiveIntensity -= .0007;	
				floor.material.color.setRGB(delta_2,delta_2,delta_2);
				scene.background.setRGB(delta_2,delta_2,delta_2);

				//UI elements
				comment_container.style.opacity = THREE.MathUtils.mapLinear(delta_2,1,0,1,.2);
				img_sound.style.filter = "brightness("+ (1-delta_2)+ ")";
				img_nosound.style.filter = "brightness("+ (1-delta_2)+ ")";
				img_comment.style.filter = "brightness("+ (1-delta_2)+ ")";
				img_nocomment.style.filter = "brightness("+ (1-delta_2)+ ")";
				logo.getElementsByTagName('img')[0].style.filter = "brightness("+ (1-delta_2)+ ")";
				title.classList.remove('slide3_title');
				title.classList.add('slide4_title');
			}
			else{
				//fade out leaves

						//fade in leaves
				if(leaves_removed == false){
					for ( let i = 0; i < scene_plants.length; i ++ ) {
						const leaf_name = 'plant_' + i.toString();
						const leaf  = scene.getObjectByName(leaf_name);

						leaf.traverse ( function (child) {
								if (child instanceof THREE.Mesh) {
									child.visible = false;
								}
							});
						
					}
					leaves_removed = true ;
				}

				scene.remove(lowerLight);
				scene.remove(upperLight);
				controls.enabled = true;
				controls.update();

			}


	}

		setTimeout(waitForLine, 10);
		})();
	});
}

/* Scene 02 LEAFS */

// Explosion of leaves in the white bg 
function Anim2() {

let removed_object = false;
let delta = 0 ;
let leaves_added = false;

	return new Promise(function (resolve, reject) {
		(function waitForLine(){

			if(continue_clicked==true){

			//fade in leaves
			if(leaves_added == false){
				for ( let i = 0; i < scene_plants.length; i ++ ) {
					const leaf_name = 'plant_' + i.toString();
					const leaf  = scene.getObjectByName(leaf_name);

					leaf.traverse ( function (child) {
							if (child instanceof THREE.Mesh) {
								child.visible = true;
							}
						});
					
				}
				leaves_added = true ;
			}
		

			Description.hide();

			title.classList.remove('slide2_title');
			title.classList.add('slide3_title');

			//fade out and delete morphing object at the beggining 
			if(mesh_2){
				if(mesh_2.material.opacity >0){
					delta +=.009; // softening variable
					mesh_2.material.opacity  = 1-delta; // fade out morph
					floor.material.opacity = THREE.MathUtils.mapLinear(delta,0,1,.8,.5); 
					floor.material.color.setRGB(delta,delta,delta);
					scene.background.setRGB(delta,delta,delta);
					// fade to black UI elements
					img_sound.style.filter = "brightness("+ (1-delta)+ ")";
					img_nosound.style.filter = "brightness("+ (1-delta)+ ")";
					img_comment.style.filter = "brightness("+ (1-delta)+ ")";
					img_nocomment.style.filter = "brightness("+ (1-delta)+ ")";
					logo.getElementsByTagName('img')[0].style.filter = "brightness("+ (1-delta)+ ")";
					continue_ref.style.display = "block";
					continue_ref.style.opacity = delta;
					continue_ref.style.filter = "brightness("+ (1-delta)+ ")";
				
					//fade in leaves
					plant_shader.uniforms.u_opacity.value = THREE.MathUtils.mapLinear(delta,0,1,0,.8);
				
				}
				
				else{
					scene.remove(mesh_2);
					removed_object = true;
				}
			}

		
				
			}

		
			if(removed_object == true)	{

				// remove light on the floor
				scene.remove(scanLight);
				scene.remove(light_gradient);
				scene.remove(light_gradient_2);
				scene.remove(mesh_gradient);
				scene.remove(mesh_gradient_2);


				description.innerHTML = "From the individual shapes of the Lexus Electrified Sport coupe, this mesmerizing interactive world sees the Lexus design language through the prism of nature’s cues. Inspired by the Japanese concept of 'shizen-to' (with nature), the pieces join to show what can happen when engineering and nature combine.";
				Description.show();

				scene.remove(scanLight);
				continue_clicked = false;

				return resolve();

			}

			setTimeout(waitForLine, 1);
		})();
	});
}


/* Scene 01 Figure */
/* -- deletes static figure and adds morphing */
function Anim1() {

	const obj1 = scene.getObjectByName('obj1'); 
	let deteled_object = false;

	return new Promise(function (resolve, reject) {
		(function waitForLine(){

				mixer_2.timeScale = 1;
				mesh_2.visible = true;


				//fade out obj1 and fade in morphing
				if(obj1){
					if(obj1.children[0].material.opacity > 0 ){
						obj1.children[0].material.opacity -= .007;
						mesh_2.material.opacity += .018;
					}
					else{
						scene.remove(obj1);
						deteled_object = true;
						upperLight.intensity =.3;
					}
		
				}

				mixer_2.addEventListener( 'finished', function( e ) {		
					title.classList.remove('slide1_title');
					title.classList.add('slide2_title');
					//activate continue button
					continue_ref.style.opacity = 1;
					continue_ref.style.display = "block";
					continue_clicked = false; 
					//change UI 
					description.innerHTML = "Pioneering artist and architect Suchi Reddy created the Shaped by Air concept as an exploration of the energy of nature. Lexus worked with Diorama to create a deep forest immersion with wisps of wind, the rusting of leaves, and rays of light.";	
					Description.show();
					if ( deteled_object == true){
						return resolve();	
					}
				} ); 

			setTimeout(waitForLine, 1);
		})();
	});
}


/* detect if device is touch */
function isTouchDevice() {
return (('ontouchstart' in window) ||
	(navigator.maxTouchPoints > 0) ||
	(navigator.msMaxTouchPoints > 0));
}

		
/* moving  with keys functions */

function fmoveForward( distance ) {

	// move forward parallel to the xz-plane
	// assumes camera.up is y-up

	_vector.setFromMatrixColumn( camera.matrix, 0 );

	_vector.crossVectors( camera.up, _vector );

	camera.position.addScaledVector( _vector, distance );
	if(touchdevice==false)
	controls.target.addScaledVector( _vector, distance);

};
		
function fmoveRight( distance ) {

	_vector.setFromMatrixColumn( camera.matrix, 0 );

	camera.position.addScaledVector( _vector, distance );
	if(touchdevice==false)
	controls.target.addScaledVector( _vector, distance );

};
	